const dev = {
  APP_URL: 'http://adx2.rpc.com.br',
  API_URL: 'http://adx2.rpc.com.br:8080',
};

const prod = {
  APP_URL: 'http://adx2.rpc.com.br',
  API_URL: 'http://adx2.rpc.com.br:8080',
};

const config = process.env.NODE_ENV === 'production' ? prod : dev;

export const interesses_url =
  'https://s3.amazonaws.com/homolog-atendimento.vocenarpc.com.br/.well-known/salesforce/interests.json';

export const NOVU_ID = 'xIOsAKW_ZHeA';

export default {
  ...config,
};
